import { getEditValuesByTiledFormData, setComValue } from '../../config';

/** Confluence 172106430（v15）：仅回填本次需求指定且机会点模板实际包含的属性。物业费/推广费属性标识以 v15 为准。 */
const SPOT_FIELDS = [
  'basicProjectPhotos', 'activePedestrianFlow', 'spotPicture', 'spotVideo',
  'spotLengthTwo', 'spotWidthTwo', 'spotSquareTwo', 'heightLimit', 'spotFloor',
  'businessTerms', 'propertyManagementMS', 'promotioncostsMS', 'approvalFee',
  'otherexpenses', 'spotDescription', 'dailyPassengerFlowSemir', 'positioningbrand',
];

/** 清空模板中由点位详情带入的字段，避免切换点位时保留上一点位的值。 */
export function clearSpotProperties(components: any[]) {
  const importedComponents = components.filter(component => SPOT_FIELDS.includes(component.identification));
  importedComponents.forEach(component => {
    component.textValue = null;
  });
  return { importedComponents, formValues: getEditValuesByTiledFormData(importedComponents) };
}

/** 资源详情字段缺失或为空时，清空上一点位带入的值。 */
const isEmptySourceValue = (value: any) => value === undefined || value === null || value === '' || value === 'null';
const normalizeSourceTextValue = (value: any) => typeof value === 'object' && value !== null
  ? JSON.stringify(value)
  : value;

export function backfillSpotProperties(propertyValueList: any[], components: any[]) {
  const sources = new Map<string, any>();
  (Array.isArray(propertyValueList) ? propertyValueList : []).forEach(source => {
    if (source?.identification) sources.set(source.identification, source.textValue);
  });
  const dimensions: Record<string, number | null> = {};
  if (sources.has('specLW')) {
    if (isEmptySourceValue(sources.get('specLW'))) {
      dimensions.spotLengthTwo = null;
      dimensions.spotWidthTwo = null;
      dimensions.spotSquareTwo = null;
    } else {
      try {
        // 历史实现：资源管理端 DynamicSpecLW 保存 [{ l, w }]，面积使用相同精度计算。
        // 当前接口已返回 area，直接回填，不再根据长宽计算面积。
        const spec = JSON.parse(sources.get('specLW'))?.[0];
        if (typeof spec?.l === 'number' && Number.isFinite(spec.l)) dimensions.spotLengthTwo = spec.l;
        if (typeof spec?.w === 'number' && Number.isFinite(spec.w)) dimensions.spotWidthTwo = spec.w;
        if (typeof spec?.area === 'number' && Number.isFinite(spec.area)) dimensions.spotSquareTwo = spec.area;
      } catch (error) {
        // 异常规格不推断，其他有效属性仍可回填。
      }
    }
  }
  const { importedComponents } = clearSpotProperties(components);
  importedComponents.forEach(component => {
    const key = component.identification;
    if (sources.has(key) && !isEmptySourceValue(sources.get(key))) {
      component.textValue = normalizeSourceTextValue(sources.get(key));
    } else if (Object.prototype.hasOwnProperty.call(dimensions, key) && dimensions[key] !== null) {
      setComValue(component, dimensions[key]);
    }
  });
  return { importedComponents, formValues: getEditValuesByTiledFormData(importedComponents) };
}
